export default {
  GET_PICKUP_DATA: 'GET_PICKUP_DATA',
  SEND_PICKUP_DATA: 'SEND_PICKUP_DATA',
  PROPOSE_NEW_TIME: 'PROPOSE_NEW_TIME',
  SET_TIME_PROPOSAL_MODE: 'SET_TIME_PROPOSAL_MODE',
  TOGGLE_SUCCESS_MESSAGE: 'TOGGLE_SUCCESS_MESSAGE',
}